import bausteineQuiz from './bausteine.quiz';
import basicInfoQuiz from'./basicInfo.quiz';
import bavQuiz from './bav.quiz';

angular
  .module('VSPApp')
  .service('bavQuiz', bavQuiz)
  .service('bausteineQuiz', bausteineQuiz)
  .service('basicInfoQuiz', basicInfoQuiz);